<template>
    <v-container class="pa-5 d-flex flex-column" fluid style="height: 100%">
        <page-title>
            Zamówienia nadane w czasie
        </page-title>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col cols="12" md="4" lg="2">
                <v-select
                    v-model="filters.reportType_name"
                    label="Rodzaj wykresu"
                    :items="reportTypes"
                    item-value
                    item-text
                    no-data-text="Nie znaleziono rodzaju"
                    solo
                    hide-details
                />
            </v-col>
            <v-col cols="12" md="6" lg="3">
                <v-select
                    v-model="filters.product_id"
                    label="Produkt"
                    :items="products"
                    item-text="name"
                    item-value="id"
                    no-data-text="Nie znaleziono produktów"
                    solo
                    hide-details
                    clearable
                />
            </v-col>
            <v-col cols="12" md="5" lg="3">
                <v-menu
                    v-model="menuFrom"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template #activator="{on}">
                        <v-text-field
                            v-model="filters.date"
                            label="Data"
                            prepend-icon="mdi-calendar"
                            readonly
                            solo
                            hide-details
                            append-icon
                            class="mt-0"
                            v-on="on"
                            @input="getSentOrdersByDate"
                            @click:clear="clearFilter('date')"
                        >
                            <template slot="append-outer">
                                <div class="d-flex flex-wrap">
                                    <v-btn
                                        icon
                                        x-small
                                        class="mt-n2"
                                        @click="getForwardDate()"
                                    >
                                        <v-icon>
                                            mdi-chevron-up
                                        </v-icon>
                                    </v-btn>
                                    <v-btn
                                        icon
                                        x-small
                                        @click="getBackwardDate()"
                                    >
                                        <v-icon>
                                            mdi-chevron-down
                                        </v-icon>
                                    </v-btn>
                                </div>
                            </template>
                        </v-text-field>
                    </template>
                    <v-date-picker
                        v-model="filters.date"
                        first-day-of-week="1"
                        @change="changeShiftFilters"
                        @input="menuFrom = false"
                    />
                </v-menu>
            </v-col>
            <v-col cols="12" md="5" lg="3">
                <v-btn
                    data-sentry-label="Wyszukiwanie nadanych zamówień"
                    color="success"
                    @click="getSentOrdersByDate"
                >
                    Szukaj
                </v-btn>
            </v-col>
        </v-row>

        <v-row justify="end">
            <v-col cols="auto">
                <v-tooltip :disabled="canGenerateReport" :open-delay="tooltipDelay" top>
                    <template #activator="{on}">
                        <div v-on="on">
                            <v-btn
                                text
                                small
                                data-sentry-label="Generuj raport"
                                :loading="actionLoading.generateReport"
                                :disabled="!canGenerateReport"
                                @click="generateReport"
                            >
                                <v-icon
                                    small
                                    left
                                    color="red"
                                >
                                    mdi-file-pdf
                                </v-icon>
                                Generuj raport
                            </v-btn>
                        </div>
                    </template>
                    <span>Odśwież dane na wykresie</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-card
            width="100%"
            height="100%"
            class="d-flex flex-column"
            :loading="actionLoading.getSentOrdersByDate"
        >
            <v-card-text style="height: 99%; width: 100%; position: relative">
                <canvas ref="chartContainer" />
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { appConfig } from '@/config.js'
import PageTitle from '@/components/common/PageTitle'

import filters from '@/mixins/dataTableFilters'
import dateFormatter from '@/mixins/dateFormatter'
import tooltipDelay from '@/mixins/tooltip'

import { errorHandler } from '@/utils/errorHandler'
import { customLocaleNumber } from '@/utils/utilityFunctions'

import { isEqual } from 'lodash'
import { Chart, BarController, CategoryScale, LinearScale, BarElement, Tooltip } from 'chart.js'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import { jsPDF } from 'jspdf'
import html2canvas from 'html2canvas'

export default {
    name: 'SentOrders',
    components: {
        PageTitle,
    },
    mixins: [ filters, dateFormatter, tooltipDelay ],
    data() {
        return {
            chart: null,
            chartData: {
                labels: ['0:00', '1:00', '2:00',
                    '3:00', '4:00', '5:00',
                    '6:00', '7:00', '8:00',
                    '9:00', '10:00', '11:00',
                    '12:00', '13:00', '14:00',
                    '15:00', '16:00', '17:00',
                    '18:00', '19:00', '20:00',
                    '21:00', '22:00', '23:00',
                ],
                data: new Array(24), // An array needs to be intialized with the same length labels have
                tooltipFootData: new Array(24),
                tooltipFootShiftData: []
            },
            menuFrom: false,
            actionLoading: {
                getSentOrdersByDate: false,
                generateReport: false
            },
            labelsHourly: [
                '0:00', '1:00', '2:00',
                '3:00', '4:00', '5:00',
                '6:00', '7:00', '8:00',
                '9:00', '10:00', '11:00',
                '12:00', '13:00', '14:00',
                '15:00', '16:00', '17:00',
                '18:00', '19:00', '20:00',
                '21:00', '22:00', '23:00',
            ],
            labelsShift: [
                '7:00 - 19:00', '19:00 - 7:00'
            ],
            appliedFilters: {
                reportType_name: '',
                product_id: '',
                date: ''
            },
        }
    },
    computed: {
        reportTypes() {
            return appConfig.reports.reportTypes
        },
        products() {
            return this.$store.state.reportsAndAnalysis.orders.sentOrders.products
        },
        savedFilters() {
            return this.$store.state.reportsAndAnalysis.orders.sentOrders.filters
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && typeof filters[item] !== 'undefined') {
                    if (this.filters.reportType_name === 'godzinowy' && item === 'date') {
                        query = this.concatItemToQuery(query, item, filters[item])
                    }
                    if (this.filters.reportType_name === 'zmianowy' && (item === 'date__gte' || item === 'date__lte')) {
                        query = this.concatItemToQuery(query, item, filters[item])
                    }
                    if (['date__gte', 'date__lte', 'date', 'reportType_name'].indexOf(item) === -1) {
                        query = this.concatItemToQuery(query, item, filters[item])
                    }
                }
            }
    

            return query
        },
        reportTitle() {
            const productSubTitle = this.filters['product_id']
                ? ` - produkt: ${this.getProductName(this.filters['product_id'])}`
                : ' - wszystkie produkty'
            
            return `Zamówienia nadane dnia ${this.formatDate(this.filters.date, false)}${productSubTitle}`
        },
        canGenerateReport() {
            return this.checkSameFilters(this.appliedFilters, this.filters)
        },
    },
    mounted() {
        this.getAllProducts()
        this.setDiagram()
    },
    destroyed() {
        this.chart.destroy()
    },
    methods: {
        checkSameFilters(appliedFilters, allFilters) {
            const newFilters = Object.fromEntries(
                Object.entries(allFilters).filter(([key])=>['reportType_name', 'product_id', 'date'].includes(key))
            )

            return isEqual(appliedFilters, newFilters)
        },
        getProductName(id) {
            return this.products.find(element => element.id === id).name
        },
        changeShiftFilters() {
            this.filters['date__gte'] = this.filters['date']
            this.filters['date__lte'] = this.getDayForward(this.filters['date__gte'])
        },
        concatItemToQuery(query, key, value) {
            if (query.length > 0) {
                return query.concat('&', `${key}=${value}`)
            }

            return query.concat(`${key}=${value}`)
        },
        async getSentOrdersByDate() {
            this.resetChart()
            this.actionLoading.getSentOrdersByDate = true

            const action = this.filters.reportType_name === 'godzinowy' ? 'getSentOrdersByDate' : 'getSentOrdersByDateCf'

            return await this.$store.dispatch(`reportsAndAnalysis/orders/${action}`, {
                query: this.filterQuery
            })
                .then(response => {
                    this.setChartData(response.data.results)
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.getSentOrdersByDate = false
                    this.appliedFilters['reportType_name'] = this.filters['reportType_name']
                    this.appliedFilters['product_id'] = this.filters['product_id']
                    this.appliedFilters['date'] = this.filters['date']
                })
        },
        getAllProducts() {
            this.$store.dispatch('reportsAndAnalysis/orders/getProducts')
                .catch(error => {
                    errorHandler(error)
                })
        },
        setDiagram() {
            Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, ChartDataLabels)

            const chartContainer = this.$refs.chartContainer

            this.chart = new Chart(chartContainer, {
                type: 'bar',
                plugins: [ChartDataLabels],
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    layout: {
                        padding: {
                            top: 20
                        }
                    },
                    scales: {
                        y: {
                            suggestedMax: 70,
                            beginAtZero: true,
                            ticks: {
                                stepSize: 10
                            }
                        }
                    },
                    plugins: {
                        datalabels: {
                            display(context) {
                                return context.dataset.data[context.dataIndex] > 0
                            },
                            anchor: 'end',
                            align: 'end',
                            offset: 4,
                            font: {
                                weight: 'bold',
                                size: 14
                            },
                        },
                        legend: {
                            display: false
                        },
                        tooltip: {
                            callbacks: {
                                footer: function(context) {
                                    const formattedQuantityStr = customLocaleNumber(context[0].chart.tooltipQtyData[context[0].dataIndex])
                                    
                                    return `Łączny nakład: ${formattedQuantityStr}`
                                }
                            }
                        }
                    }
                },
                tooltipQtyData: [],
                data: {
                    labels: this.chartData.labels,
                    datasets: [{
                        label: 'Ilość zamówień',
                        data: this.chartData.data,
                        backgroundColor: '#2196F3',
                        borderWidth: 0,
                        borderRadius: 5,
                    }]
                },
            })
        },
        resetChart() {
            this.chartData.labels = this.filters.reportType_name === 'godzinowy' ? this.labelsHourly : this.labelsShift
            this.chartData.data = []
            this.chartData.tooltipFootShiftData = []
            this.chart.data.labels = this.chartData.labels
            if (this.$refs.chartContainer) this.chart.update()
        },
        setChartData(ordersByHour) {
            if (this.filters.reportType_name === 'godzinowy') {
                this.chartData.data = [...new Array(24)].map((item, index) => {
                    const hour = ordersByHour.find(item => item.hour === index)

                    return typeof hour !== 'undefined' ? hour.count : 0
                })

                this.chartData.tooltipFootData = [...new Array(24)].map((item, index) => {
                    const hour = ordersByHour.find(item => item.hour === index)

                    return typeof hour !== 'undefined' ? hour.qty : 0
                })

                this.chart.tooltipQtyData = this.chartData.tooltipFootData
            }

            if (this.filters.reportType_name === 'zmianowy') {
                let firstShiftData = 0
                let secondShiftData = 0
                let firstShiftQty = 0
                let secondShiftQty = 0

                let filteredDataFirstShift = ordersByHour.filter(item => item.date == this.filters['date__gte'] && (item.hour >= 7 && item.hour < 19))

                if (filteredDataFirstShift.length > 0) {
                    firstShiftData = filteredDataFirstShift.map(item => item.count).reduce((a, b) => a + b)
                    firstShiftQty = filteredDataFirstShift.map(item => item.qty).reduce((a, b) => a + b)
                }

                this.chartData.data.push(firstShiftData)
                this.chartData.tooltipFootShiftData.push(firstShiftQty)

                let filteredDataSecondShift = ordersByHour.filter(item =>
                    item.date == this.filters['date__gte'] && (item.hour >= 19) || item.date == this.filters['date__lte'] && (item.hour < 7)
                )

                if (filteredDataSecondShift.length > 0) {
                    secondShiftData = (filteredDataSecondShift.map(item => item.count).reduce((a, b) => a + b))
                    secondShiftQty = filteredDataSecondShift.map(item => item.qty).reduce((a, b) => a + b)
                }
                    
                this.chartData.data.push(secondShiftData)
                this.chartData.tooltipFootShiftData.push(secondShiftQty)

                this.chart.tooltipQtyData = this.chartData.tooltipFootShiftData
            }
            this.chart.data.datasets[0].data = this.chartData.data

            this.setColor(this.chart.data.datasets[0].data)

            if (this.$refs.chartContainer) this.chart.update()
        },
        setColor(dataset) {
            this.chart.data.datasets[0].backgroundColor = []
            dataset.forEach(item => {
                if (item <= 50) {
                    this.chart.data.datasets[0].backgroundColor.push('#ff1a1a')
                } else if (item <= 100) {
                    this.chart.data.datasets[0].backgroundColor.push('#ff751a')
                } else {
                    this.chart.data.datasets[0].backgroundColor.push('#00cc44')
                }

            })
        },
        getBackwardDate() {
            if (Date.parse(this.filters.date)) {
                this.filters['date'] = this.getDayBackward(this.filters['date'])
                this.filters['date__gte'] = this.getDayBackward(this.filters['date__gte'])
                this.filters['date__lte'] = this.getDayBackward(this.filters['date__lte'])
            }
        },
        getForwardDate() {
            if (Date.parse(this.filters.date)) {
                this.filters['date'] = this.getDayForward(this.filters['date'])
                this.filters['date__gte'] = this.getDayForward(this.filters['date__gte'])
                this.filters['date__lte'] = this.getDayForward(this.filters['date__lte'])
            }
        },
        generateReport() {
            this.actionLoading.generateReport = true

            html2canvas(this.$refs.chartContainer)
                .then(canvas => {
                    const imgData = canvas.toDataURL('image/png'),
                        doc = new jsPDF({
                            orientation: 'landscape'
                        })

                    doc.text(`${this.reportTitle}`, 10, 10)
                    doc.addImage(imgData, 'PNG', 10, 40, 275, 130)
                    doc.setFontSize(10)

                    doc.text(`Wygenerowano: ${this.formatDate(new Date())}`, 10, 200)

                    window.open(doc.output('bloburl'), '_blank')
                    this.actionLoading.generateReport = false

                })
                .catch(() => {
                    this.actionLoading.generateReport = false
                })
        },
        close() {
            this.$router.push({ name: 'reportingAndAnalysisOrdersOrders' })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>